export default "__VITE_ASSET__BWgYVfhC__"